import { CalendarCheck, Phone } from "lucide-react";
import { FIRM } from "@/data/content";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-border bg-background/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={FIRM.phoneHref}
        data-testid="mobile-call-btn"
        className="flex items-center justify-center gap-2 py-4 text-xs font-semibold uppercase tracking-[0.15em] text-foreground transition-colors hover:text-gold"
      >
        <Phone className="h-4 w-4 text-gold" strokeWidth={1.5} /> Call
      </a>
      <button
        data-testid="mobile-book-btn"
        onClick={() => window.dispatchEvent(new CustomEvent("hlt:open-booking"))}
        className="flex cursor-pointer items-center justify-center gap-2 bg-gold py-4 text-xs font-semibold uppercase tracking-[0.15em] text-primary-foreground transition-all duration-300 hover:brightness-110"
      >
        <CalendarCheck className="h-4 w-4" strokeWidth={1.5} /> Book Free
      </button>
    </div>
  );
}
